import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MapTrafficVolumeCacheType } from 'app/components/dashboard/network/map/MapTrafficVolumeCache';

//type of the state managed by the reducer
interface MapFullscreenDataState {
    loadingData: number; //using a number instead of a boolean because multiple and async requests could be triggered at the same time and we just want to show the loading when there is something running and once each process finished it just needs to decrement the counter
    tvCache: MapTrafficVolumeCacheType;
}

const initialState: MapFullscreenDataState = {
    //empty
    loadingData: 0,
    tvCache: {},
};

/**
 * slice to save/handle data related to the fullscreen map
 */
const fullscreenDataSlice = createSlice({
    name: 'mapFullscreenData', // string that will be used as the prefix for generated action types
    initialState,
    reducers: {
        setLoadingData(state: MapFullscreenDataState, action: PayloadAction<number>) {
            state.loadingData += action.payload;
        },
        setTVCache(state: MapFullscreenDataState, action: PayloadAction<MapTrafficVolumeCacheType>) {
            state.tvCache = action.payload;
        },
    },
    extraReducers(builder) {
        //TODO add here the cache REST call
    },
});

export const { setLoadingData, setTVCache } = fullscreenDataSlice.actions;
export default fullscreenDataSlice.reducer;
